import * as React from "react";
import { useCpFormValue } from "../../../gvc/testNewForm/utils";
import { HetznerDedicatedServerNodePools } from "./hetzner/dedicServNodePools";
import { LambdalabsUnmanagedNodePools } from "./lambdalabs/unmanagedNodePools";
import { OblivusUnmanagedNodePools } from "./oblivus/unmanagedNodePools";
import { PaperspaceUnmanagedNodePools } from "./paperspace/unmanagedNodePools";

interface Props {}
export const UnmanagedNodePools: React.FC<Props> = ({}) => {
  const provider = useCpFormValue(`provider`);

  if (provider === "hetzner") {
    return <HetznerDedicatedServerNodePools />;
  }

  if (provider === "lambdalabs") {
    return <LambdalabsUnmanagedNodePools />;
  }

  if (provider === "oblivus") {
    return <OblivusUnmanagedNodePools />;
  }

  if (provider === "paperspace") {
    return <PaperspaceUnmanagedNodePools />;
  }

  return null;
};
